"use client";

import NotFoundContainer from "@/container/not-found";
export default function NotFound() {
  return <NotFoundContainer data-sentry-element="NotFoundContainer" data-sentry-component="NotFound" data-sentry-source-file="not-found.tsx" />;
}